// helper function
const constructSlug = value => (value ? `/${value}` : "");

// List of slugs
export const slugId = ":id?";
export const slugUid = ":uid?";
export const slugToken = ":token?";
export const slugThreshold = ":threshold";

// List of routes
export const main = "/";
export const signIn = "/login";
// export const signUp = "/signup";
export const resetPassword = "/reset-password";
export const restorePassword = "/restore-password";
export const activateAccount = "/signup/invite";

export const clients = (id = slugId) => `/clients${constructSlug(id)}`;

export const audiences = (id = slugId) => `/audiences${constructSlug(id)}`;
export const crm = "/crm";
export const audiencesCreate = "/audience/create";
export const audiencesCreateWithoutTemplate = (id = slugId) =>
  `/audience/create/builder${constructSlug(id)}`;
export const trash = "/trash";

export const fullReport = "/full-report";
export const fullReportPdf = (id = slugId, threshold = slugThreshold) =>
  `/report/pdf/${id}/${threshold}`;

export const accountUpgrade = "/account/upgrade";
export const accountProfile = "/account/profile";
export const accountOverview = "/account/overview";
export const clientActivities = (id = slugId) =>
  `/account/client-activities${constructSlug(id)}`;

export const guide = "/guide";
export const apiAccess = "/account/api-access";
